<style lang="scss">
  @use "../../../../assets/css/design-system/mixins";
  @use "../../../../assets/css/design-system/colors";

  .time-selector-item {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px 8px;
    cursor: pointer;
    white-space: nowrap;
    border: none;
    border-radius: 8px;
    background: transparent;
    outline: none;
    @include mixins.body3();
    transition: all 0.2s;

    &.selected {
      @include colors.background-color(primary_50);
      @include colors.color(interfaceWhite);
    }

    &:hover {
      &:not(.selected) {
        @include colors.background-color(interfaceSwGrey_10);
      }
    }

    &:focus {
      outline: none;
    }
  }
</style>

<script>
  let { children, selected = false, onclick } = $props();
</script>

<button class="time-selector-item" class:selected {onclick}>
  {@render children()}
</button>
